import { Flex, Text } from '@chakra-ui/react';
import { Card } from '@ui/components/Card';
import { CoinModeSwitchTab } from '@ui/components/CoinModeSwitchTab';
import DesktopBg from '@ui/components/DesktopBg';
import HowItWorksDrawer from '@ui/components/HowItWorksDrawer';
import WithWallet from '@ui/components/Wallet/WithWallet';
import { pathDict } from '@ui/config/paths';
import { COIN_MODE, useCoinMode } from '@ui/hooks/useCoinMode';
import { HintType } from '@ui/hooks/useShowHowItWorks';
import { useTranslations } from '@ui/i18n';
import router from '@ui/overrides/next/router';

import { ClaimView } from '../Claim';
import { UnstakeView } from '../Unstake';
import { useUnstakeHint } from './howItWorks';

export const UnstakeAndClaimDesktop = () => {
  const t = useTranslations();
  const globalCoinMode = useCoinMode();
  const coinModeInfo = COIN_MODE[globalCoinMode];

  return (
    <>
      <DesktopBg
        pattern={
          globalCoinMode === 'atom'
            ? 'PATTERN_2_ATOM'
            : globalCoinMode === 'eth'
            ? 'UNSTAKE_ETH_BG_DESKTOP'
            : 'PATTERN_2'
        }
      />
      <HowItWorksDrawer
        hintType={HintType.UNSTAKE}
        {...useUnstakeHint()}
        transparentOverlayHeightPx={115}
      />

      <Flex flexDir="column" gap="19px" alignItems="center">
        <Flex gap={1} w="full">
          <CoinModeSwitchTab
            mr="10px"
            onCoinModeChange={(coinMode) => {
              router.push(pathDict[coinMode].unstake);
            }}
          >
            {(coinMode) =>
              t('Unstake {coin}', {
                coin: COIN_MODE[coinMode].name,
              })
            }
          </CoinModeSwitchTab>
          <WithWallet
            maxW="calc(100% - 180px)"
            mt="7px"
            actionHint={t('Unstake {coin}', {
              coin: coinModeInfo.name,
            })}
            mx="auto"
          >
            <Flex>
              <Card flexGrow="1" width={0} px={6} pt={4} mx={0} mr="10px">
                <Text textStyle="h3">
                  {t('Unstake {coin}', {
                    coin: coinModeInfo.name,
                  })}
                </Text>
                <UnstakeView />
              </Card>
              <Card flexGrow="1" width={0} px={6} pt={4} mx={0} ml="10px">
                <Text textStyle="h3" mb="33px">
                  {t('Claim {coin}', {
                    coin: coinModeInfo.name,
                  })}
                </Text>
                <ClaimView />
              </Card>
            </Flex>
          </WithWallet>
        </Flex>
      </Flex>
    </>
  );
};
